import { render, staticRenderFns } from "./YA_LanguageSwitcher.vue?vue&type=template&id=629f3987&scoped=true"
import script from "./YA_LanguageSwitcher.vue?vue&type=script&lang=js"
export * from "./YA_LanguageSwitcher.vue?vue&type=script&lang=js"
import style0 from "./YA_LanguageSwitcher.vue?vue&type=style&index=0&id=629f3987&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "629f3987",
  null
  
)

export default component.exports